/**
 * filename: TruncatedList.jsx
 * date: 2018-06-14
 * author: Tony Garcia
 * description: Component that truncates a list to a desired length with option to show all items
 *  based on https://github.com/tedconf/react-show-more
 */

import { useState } from "react";
import PropTypes from "prop-types";

const TruncatedList = ({ children, items = [], visibleItemsCount = 20 }) => {
  const [showAll, setShowAll] = useState(false);

  const getHashList = () =>
    showAll ? items : items.slice(0, visibleItemsCount);

  const visibleItems = getHashList();

  if (typeof children === "function") {
    return children({
      visibleItems,
      more: items.length > visibleItems.length,
      getHashList: setShowAll
    });
  }
  throw new Error("prop `children` must be a function");
};

TruncatedList.propTypes = {
  children: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.any),
  visibleItemsCount: PropTypes.number
};

export default TruncatedList;
